/**
 * ScrollContainer — wrapper de scroll horizontal (y opcionalmente vertical) para listados.
 *
 * Todos los listados del config deben poder scrollear horizontal cuando las columnas no
 * entran. Envolvé la <table> (o el grid) con esto en lugar de repetir overflow-x-auto suelto.
 *
 * Ver: docs/design-system/COMPONENT_CATALOG.md
 */
import React from 'react';

interface Props {
  /** Si se pasa, habilita scroll vertical con ese alto máximo (ej. '50vh', 420). */
  maxHeight?: string | number;
  className?: string;
  children: React.ReactNode;
}

const ScrollContainer: React.FC<Props> = ({ maxHeight, className = '', children }) => {
  return (
    <div
      className={`overflow-x-auto ${maxHeight ? 'overflow-y-auto' : ''} ${className}`}
      style={maxHeight ? { maxHeight } : undefined}
    >
      {children}
    </div>
  );
};

export default ScrollContainer;
